import { signal, computed, batch } from '@preact/signals';

// ── Core chat state signals ──────────────────────────────────────────────────
export const messages      = signal([]);
export const isOpen        = signal(false);
export const isLoading     = signal(false);
export const isStreaming   = signal(false);
export const unreadCount   = signal(0);
export const suggestions   = signal([]);
export const showTyping    = signal(false);
export const showHistory   = signal(false);
export const showReview    = signal(false);
export const isMobile      = signal(false);
export const isCompact     = signal(false);
export const isMinimized   = signal(false);
export const toastMessage  = signal(null);
export const historyError  = signal(null);
export const historySessions = signal(null); // null = not loaded, [] = empty

// ── Computed ─────────────────────────────────────────────────────────────────
export const hasUnread = computed(() => unreadCount.value > 0);
export const canSend   = computed(() => !isLoading.value);

// ── Actions ──────────────────────────────────────────────────────────────────
export function addMessage(msg) {
  messages.value = [...messages.value, msg];
}

export function updateStreamingMessage(id, text) {
  messages.value = messages.value.map(m =>
    m.id === id ? { ...m, text, streaming: true } : m
  );
}

export function finalizeStreamingMessage(id, text, timestamp) {
  messages.value = messages.value.map(m =>
    m.id === id ? { ...m, text, streaming: false, ...(timestamp ? { timestamp: new Date(timestamp).getTime() } : {}) } : m
  );
}

export function removeMessage(id) {
  messages.value = messages.value.filter(m => m.id !== id);
}

export function updateMessageTimestamp(id, isoTimestamp) {
  messages.value = messages.value.map(m =>
    m.id === id ? { ...m, timestamp: new Date(isoTimestamp).getTime() } : m
  );
}

export function clearMessages() {
  messages.value = [];
}

export function setOpen(val) {
  batch(() => {
    isOpen.value = val;
    if (val) { unreadCount.value = 0; }
  });
}

export function showToast(msg, durationMs = 4500) {
  toastMessage.value = msg;
  setTimeout(() => { toastMessage.value = null; }, durationMs);
}

export function resetForNewSession(welcomeMessages) {
  batch(() => {
    messages.value       = welcomeMessages;
    isLoading.value      = false;
    isStreaming.value     = false;
    showTyping.value      = false;
    showHistory.value     = false;
    showReview.value      = false;
    toastMessage.value    = null;
    historySessions.value = null;
  });
}

export function updateMessageMeta(id, { sources, toolCalls, structured } = {}) {
  messages.value = messages.value.map(m => {
    if (m.id !== id) return m;
    return {
      ...m,
      ...(sources    !== undefined && { sources }),
      ...(toolCalls  !== undefined && { toolCalls }),
      ...(structured !== undefined && { structured }),
    };
  });
}
